import React, { useState } from 'react'

import {
  StyleSheet,
  View,
  Text,
  Dimensions
} from 'react-native'

import {
  adaptive, typography, colors
} from '@sart/styles'

import { useContent } from '@sart/content'
import { Pdf } from '../Components'

export default function ViewBill(props) {
  // const { navigation } = props
  const content = useContent()
  const [source, setSource] = useState({uri: 'file:///Users/admin/sandbox/selfservicesuite/apps/srvno-apps/apps/mySR/src/Bills/example.pdf'})

  return (
    <View style={styles.container}>
        {source === undefined && 
            <View style={styles.textContainer}>
                <Text style={styles.text}>{content.viewBill.notAvailable}</Text>
            </View>
        }
        {source &&
            //PDF COMPONENT REMOVED AS OUTDATED
            <></>
        }
    </View>
  )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginTop: 25,
        ...adaptive.wrapperPadding
    },
    pdf: {
        flex:1,
        width:  Dimensions.get('window').width,
        height:  Dimensions.get('window').height,
    },
    text: {
        color: colors.srDarkGreen,
        fontSize: 16,
        ...typography.lightbold,
        textAlign: 'center',
    },
    textContainer: {
        flex: 0.4,
        justifyContent: 'center',
    }
})
